import React, { Component } from "react";
import { CardElement, ElementsConsumer } from "@stripe/react-stripe-js";
import Popup from "reactjs-popup";
import { fire, auth } from "../../firebase/index";
import { FadeLoader } from "react-spinners";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import withAuthorization from "../../components/Authorization/withAuthorization";
import { Redirect } from "react-router-dom";
import {
  egeeTouchPlans,
  deploymentEnvironment,
  planToNumber,
} from "../../variables/Variables";

import { customLog } from "../../variables/Variables";

import {
  //   planToNumber,
  getToday,
  cancelSub,
  showConfirmAlert,
  updateUserDetails,
} from "./StripeHelper";

import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    submitButton: "Submit",
    trialTitle: "Free 1 month trial period",
    padlockTitle: "Smart Padlocks",
    userAccountsTitle: "User Accounts",
    nfcTitle: "Tags",
    maxMultiTitle: "Layer of Multi Approval",
    uptoTitle: "Up to",
  },
  ja: {
    submitButton: "参加する",
    trialTitle: "1ヶ月無料トライアル",
    padlockTitle: "南京錠",
    userAccountsTitle: "ユーザーアカウント",
    nfcTitle: "タグ",
    maxMultiTitle: "複数の承認のレイヤー",
    uptoTitle: "まで",
  },
  es: {
    submitButton: "Enviar",
    trialTitle: "Período de prueba gratuito de 1 mes",
    padlockTitle: "Candados Inteligentes",
    userAccountsTitle: "Cuentas de Usuario",
    nfcTitle: "Etiquetas",
    maxMultiTitle: "Capa de Aprobación Múltiple",
    uptoTitle: "Hasta",
  },
});

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

class CustomPlan extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      planSelected: "1-Year Custom",
      loading: false,
      _notificationSystem: null,
      errorMessage: "",
      existingPlan: false,
      stripeSubscriptionId: null,
      openCarousel: false,
      redirect: false,
      subscribedBefore: false,
      trialEnded: false,
      trialEndDate: undefined,
      currentPlan: "",
      // email: auth.currentUser.email
      name: "",
      currentLanguage: "",

      //for custom plan variables
      planId: egeeTouchPlans.egeeTouchplan4.planId,
      planPrice: egeeTouchPlans.egeeTouchplan4.planPrice, //MONTHLY - planPrice , ANNUAL - planPriceAnnual
      maxAcc: egeeTouchPlans.egeeTouchplan4.maxAcc,
      maxLocks: egeeTouchPlans.egeeTouchplan4.maxLocks,
      maxTags: egeeTouchPlans.egeeTouchplan4.maxTags,
      maxMulti: egeeTouchPlans.egeeTouchplan4.maxMulti,
      originalDisplayPrice: egeeTouchPlans.egeeTouchplan4.originalDisplayPrice,
      discountedDisplayPrice:
        egeeTouchPlans.egeeTouchplan4.discountedDisplayPrice,
      discountDisplay: egeeTouchPlans.egeeTouchplan4.discountDisplay,
      planDurationTitle: egeeTouchPlans.egeeTouchplan4.planDurationDisplay,
      planNameTitle: egeeTouchPlans.egeeTouchplan4.planName,
      // trial_period_days: egeeTouchPlans.egeeTouchplan4.trial_period_days,

      //custom code
      customPlanCode: egeeTouchPlans.egeeTouchplan4.customCode,
    };

    this.cancelSub = this.cancelSub.bind(this);
    this.submit = this.submit.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.popupForm = this.popupForm.bind(this);
  } // end of constructor

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    //? Check if user have existing plan.

    fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid)
      .once("value")
      .then((ss) => {
        if (ss.exists()) {
          const data = ss.val();
          const subId = data.payment.stripeSubscriptionId;
          const trialEndDate = data.payment.trialEndDate;
          // customLog(data.payment.isPaymentValid);
          customLog(data, subId, trialEndDate);

          if (data.payment.isPaymentValid) {
            this.setState({
              stripeSubscriptionId: subId,
              existingPlan: true,
              currentPlan: data.payment.plan,
            });

            // customLog(subId);
          } else {
            //if payment valid false and snapshot exists
            //User has subscribed before / fail
            this.setState({
              subscribedBefore: true,
            });
          }

          if (trialEndDate <= Math.floor(Date.now() / 1000)) {
            this.setState({
              trialEnded: true,
            });
          }

          this.setState({
            trialEndDate: trialEndDate,
          });
        } else {
          this.setState({
            subscribedBefore: false,
          });
        }
      })
      .catch((err) => {
        customLog(err);
      });

    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    fire
      .database()
      .ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .on("value", (snapshot) => {
        this.setState({
          name: snapshot.val().name,
        });
      });
  }

  openModal(btnClick) {
    // if (this.state.existingPlan) {
    //   console.log("Changing plan?");
    //   console.log(btnClick);
    //   const changeTitle = "Change Plan";
    //   const changeMsg = `Do you want to switch to ${btnClick} plan ?`;
    //   const changeBtn = [
    //     {
    //       label: "Confirm",
    //       onClick: () => {
    //         console.log("changing plan! ");
    //       }
    //     },
    //     {
    //       label: "Close",
    //       onClick: () => {
    //         return false;
    //       }
    //     }
    //   ];
    //   showConfirmAlert(changeTitle, changeMsg, changeBtn);
    // } else {
    this.setState({ open: true });
    this.setState({
      planSelected: egeeTouchPlans.egeeTouchplan4.planName,
      planId: egeeTouchPlans.egeeTouchplan4.planId,
      planPrice: egeeTouchPlans.egeeTouchplan4.planPrice, //MONTHLY - planPrice , ANNUAL - planPriceAnnual
    });
    // }
  }
  closeModal() {
    this.setState({ open: false });
  }

  async submit(ev) {
    this.setState({ loading: true });
    const creditCardName = document.getElementById("creditCardName").value;
    const creditCardAddr = document.getElementById("creditCardAddr").value;
    const notification = this.state._notificationSystem;
    customLog("=== Submit button clicked ===");
    //!User clicked submit
    await this.props.stripe
      .createPaymentMethod({
        type: "card",
        card: this.props.elements.getElement(CardElement),
      })
      .then(async (result) => {
        this.closeModal();
        customLog(result);
        customLog(result.paymentMethod.id);

        let url = "";

        if (deploymentEnvironment) {
          url =
            "https://us-central1-egeetouchindustrial.cloudfunctions.net/liveStripeChargeNewCUSTOMPLAN3DS";
          customLog("Live Environment @ StripeBtn");
        } else {
          url =
            "https://us-central1-egeetouchindustrial.cloudfunctions.net/testStripeChargeNewCUSTOMPLAN3DS";
          customLog("Test Environment @ StripeBtn");
        }

        //Try out
        let testData = {
          paymentMethodId: result.paymentMethod.id,
          email: auth.currentUser.email,
          planName: this.state.planSelected,
          planPrice: this.state.planPrice,
          planId: this.state.planId,
          trialEndDate: "",
          trialEnded: false,
          currentUser: auth.currentUser.uid,
          name: this.state.name,
          maxLocks: egeeTouchPlans.egeeTouchplan4.maxLocks,
          maxUsers: egeeTouchPlans.egeeTouchplan4.maxAcc,
          maxMulti: egeeTouchPlans.egeeTouchplan4.maxMulti,
          language: this.state.currentLanguage,
          trial_period_days: egeeTouchPlans.egeeTouchplan4.trial_period_days,
        };

        if (this.state.trialEndDate !== undefined) {
          testData.trialEndDate = this.state.trialEndDate;
        }

        if (this.state.trialEnded === true) {
          testData.trialEnded = true;
        }

        // //Try out
        // let testData = {
        //   token: result.token.id,
        //   email: auth.currentUser.email,
        //   planName: this.state.planSelected,
        //   planPrice: this.state.planPrice,
        //   planId: this.state.planId,
        //   currentUid: auth.currentUser.uid,
        //   name: this.state.name,
        //   maxLocks: egeeTouchPlans.egeeTouchplan4.maxLocks,
        //   maxUsers: egeeTouchPlans.egeeTouchplan4.maxAcc,
        //   maxMulti: egeeTouchPlans.egeeTouchplan4.maxMulti,
        //   language: this.state.currentLanguage,
        // };

        let response = await fetch(url, {
          method: "POST",
          body: JSON.stringify(testData),
        }).catch((err) => {
          customLog(err);
        });

        customLog(`here is the response: ${response}`);

        //? If there's response from the firebase function
        let returnedVal = await response.json();

        customLog(`checking the returned val: ${returnedVal}`);

        if (returnedVal.requiresAction && returnedVal.clientSecret) {
          const confirm =
            returnedVal.intentType === "setup"
              ? await this.props.stripe.confirmCardSetup(
                  returnedVal.clientSecret
                )
              : await this.props.stripe.confirmCardPayment(
                  returnedVal.clientSecret
                );

          if (confirm.error) {
            this.setState({ loading: false });
            this.state._notificationSystem.addNotification({
              title: <span data-notify="icon" className="pe-7s-gift"></span>,
              message: (
                <div>
                  Your card has been <b>declined</b> !
                </div>
              ),
              level: "error",
              position: "tc",
              autoDismiss: 10,
            });
            return;
          }
          // 3DS authentication succeeded — treat the same as an immediate success
          returnedVal.message = "Subscribed";
        }

        if (returnedVal.message === "Subscribed") {
          const stripeSubId = returnedVal.response.id;
          const stripeCustomerId = returnedVal.response.customer;

          customLog(creditCardAddr);
          customLog(creditCardName);

          this.setState({
            loading: false,
            stripeSubscriptionId: stripeSubId,
          });

          this.closeModal();

          let planToNumberResponse = planToNumber(this.state.planSelected);
          let planNumber = egeeTouchPlans.egeeTouchplan4.planNumber;
          // let maxUser = planToNumberResponse.maxUsers;

          //? The Value that is sent back by firebase cloud function.
          var returnedMessage = returnedVal.message;
          if (returnedMessage === "Subscribed") {
            // customLog("HEY YES USER CAN BE SUBSCRIBED");

            //TODO: Update DB:
            const paidDate = returnedVal.response.current_period_start;
            const customerId = returnedVal.response.customer;
            const planSelected = this.state.planSelected;
            const currentUserUid = auth.currentUser.uid;

            const cardLastFour = result.paymentMethod.card.last4;
            const cardExpMonth = result.paymentMethod.card.exp_month;
            const cardExpYear = result.paymentMethod.card.exp_year;
            const cardExp = cardExpMonth + "/" + cardExpYear;

            let today;
            const fireDbGroupAccounts = fire
              .database()
              .ref("groupAccounts")
              .child(currentUserUid);

            getToday((response) => {
              today = response;
            });

            //24*60*60 = 86400 (1 day)
            // const oneMonthTimeStamp = 2678400;
            const oneYearTimeStamp = 31536000;

            //const twoYearTimeStamp = 63072000;

            const ONE_DAY_TIMESTAMP = 86400;

            const trial_period_days =
              egeeTouchPlans.egeeTouchplan4.trial_period_days !== 0 &&
              egeeTouchPlans.egeeTouchplan4.trial_period_days !== null
                ? egeeTouchPlans.egeeTouchplan4.trial_period_days
                : 0;
            // const trialPeriodDays = (egeeTouchPlans.egeeTouchplan4.trial_period_days !== 0 || egeeTouchPlans.egeeTouchplan4.trial_period_days !== null) ?  egeeTouchPlans.egeeTouchplan4.trial_period_days : 0 ;
            const trial_period_timeStamp =
              trial_period_days === 0
                ? 0
                : trial_period_days * ONE_DAY_TIMESTAMP;
            // trial_period_days * ONE_DAY_TIMESTAMP;

            const trialEndOrStartDeuctDATE = paidDate + trial_period_timeStamp;

            const dbGroupMembers = {
              isAdmin: true,
              isSuperAdmin: true,
              memberAddedOn: paidDate,
              memberEmail: auth.currentUser.email,
              memberUid: "push.key",
            };

            let dbPayments = {
              currentPaymentType: "STRIPE",
              currentRedemptionActiveCode: "",
              currentPlanId: egeeTouchPlans.egeeTouchplan4.planId,
              dateLastPayment: paidDate,
              isPaymentValid: true,
              maxMulti: egeeTouchPlans.egeeTouchplan4.maxMulti,
              plan: planNumber,
              planType: "MONTHLY", // CUSTOM PLAN ONLY FOR ANNUAL and MONTHLY SUBSCRIPTIONS
              specialTrialMode: false,
              startMonthlyCycle: today,
              startedOn: paidDate,
              planEndDate: trialEndOrStartDeuctDATE,
              trialEndDate: null,
              onTrialPeriod: false,
              stripeSubscriptionId: stripeSubId,
              stripeCustomerId: stripeCustomerId,
              maxLocks: egeeTouchPlans.egeeTouchplan4.maxLocks,
              maxUsers: egeeTouchPlans.egeeTouchplan4.maxAcc,
              maxTags: egeeTouchPlans.egeeTouchplan4.maxTags,
              cardName: creditCardName,
              billingAddr: creditCardAddr,
              cardLastFourDigit: cardLastFour,
              cardExp: cardExp,
              customPromoCode: egeeTouchPlans.egeeTouchplan4.customCode,
            };

            // if (this.state.trialEndDate !== undefined) {
            //   dbPayments.trialEndDate = this.state.trialEndDate;
            // }

            if (this.state.trialEnded === true) {
              dbPayments.onTrialPeriod = false;
            }

            const groupAccSchema = {
              created_on: paidDate,
              groupName: "My First Group",
              payment: dbPayments,
            };
            customLog("Hello check trial " + trialEndOrStartDeuctDATE);

            //check if user has existing redeemedRedemptionCode in groupAccount payments
            //if exist -> delete

            fire
              .database()
              .ref("groupAccounts")
              .child(auth.currentUser.uid)
              .child("payment")
              .child("redeemedRedemptionCode")
              .once("value")
              .then((snap) => {
                if (snap.exists()) {
                  snap.ref.remove();
                }
              });

            if (this.state.subscribedBefore) {
              //update payment details
              customLog("User has subscribed before ! ");
              customLog("Updating payment details...");

              customLog("Upading groupAccount Payment...");
              fireDbGroupAccounts.child("payment").update(dbPayments);

              customLog("Updating User Details...");
              await updateUserDetails(paidDate, customerId, planSelected).then(
                () => {
                  setTimeout(() => {
                    this.setState({
                      existingPlan: true,
                      redirect: true,
                    });
                  }, 2000);
                }
              );

              var level = "success"; // 'success', 'warning', 'error' or 'info'
              notification.addNotification({
                title: <span data-notify="icon" className="pe-7s-gift"></span>,
                message: (
                  <div>
                    Subscription successful ! Thank you, we hope you Enjoy
                  </div>
                ),
                level: level,
                position: "tc",
                autoDismiss: 10,
              }); //End of notificationSystem.addNotification({})
            } else {
              customLog("User have not subscribe before !");

              customLog("Pushing to groupAccount...");
              fireDbGroupAccounts
                .set(groupAccSchema)
                .then(async (response) => {
                  // fireDbGroupAccounts.child(admins).push(dbAdmins);
                  const today = new Date();

                  let groupMembersKey = fireDbGroupAccounts
                    .child("members")
                    .push(dbGroupMembers).key;

                  customLog("Updating group account members...");
                  fireDbGroupAccounts
                    .child("members/" + groupMembersKey)
                    .update({
                      memberUid: groupMembersKey,
                      memberEmail: auth.currentUser.email,
                      memberAddedOn: today.getTime(),
                    });

                  const randomKey = fireDbGroupAccounts.child("groupID").push()
                    .key;

                  customLog("Setting group ID");
                  fireDbGroupAccounts.child("groupID").set(randomKey);

                  //? If payment is successful, It'll return "Subscribed" from firebase function.
                  //Success returns a white colour background for notification.
                  var level = "success"; // 'success', 'warning', 'error' or 'info'
                  notification.addNotification({
                    title: (
                      <span data-notify="icon" className="pe-7s-gift"></span>
                    ),
                    message: (
                      <div>
                        Subscription successful ! Thank you, we hope you Enjoy
                      </div>
                    ),
                    level: level,
                    position: "tc",
                    autoDismiss: 10,
                  }); //End of notificationSystem.addNotification({})

                  customLog("Updating user details ...");
                  await updateUserDetails(paidDate, customerId, planSelected);

                  setTimeout(() => {
                    this.setState({
                      existingPlan: true,
                      redirect: true,
                    });
                  }, 2000);
                })
                .catch((err) => {
                  customLog(err);
                });
            }

            //update the claimDetails & isClaimed = true in CustomPlanSubscriptions collection
            const dateClaim = Math.floor(Date.now() / 1000);

            customLog("Updating CustomPlanSubcriptions...");
            fire
              .database()
              .ref("CustomPlanSubscriptions/" + this.state.customPlanCode)
              .update({
                claimDetails: {
                  claimedOn: dateClaim,
                  userEmail: auth.currentUser.email,
                  userUID: auth.currentUser.uid,
                },
                isClaimed: true,
              });

            // customLog(returnedVal.response.current_period_start);
            // customLog(returnedVal.response.customer);
            // customLog(this.state.planSelected);
          } else {
            //? If payment fail, it'll return "FAILED" form firebase function.
            //!This will set a red error message before the submit button.
            this.setState({
              errorMessage: "And error occurred. Please try again later.",
            });
          }
        } //end of if response.ok
        else {
          this.setState({ loading: false });
          this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                Payment <b>failed, Please try again later</b> !
              </div>
            ),
            level: "error",
            position: "tc",
            autoDismiss: 10,
          }); //End of notificaton
        }
        //! To check the Token Id after submit button is press.
        // customLog(token.id);
      })
      .catch((err) => {
        customLog(err);
        this.setState({ loading: false });
        this.state._notificationSystem.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: <div>Invalid card, Please try again !</div>,
          level: "error",
          position: "tc",
          autoDismiss: 10,
        }); //End of notificat
      });
  } //end of async submit(ev)

  cancelSub() {
    if (this.state.existingPlan) {
      const delTitle = "We're sad to see you go !";
      const delMessage = "Confirm cancellation of subscription ?";
      const delButton = [
        {
          label: "Confirm",
          onClick: () => {
            this.setState({ loading: true });
            const details = {
              subId: this.state.stripeSubscriptionId,
              uid: auth.currentUser.uid,
              language: this.state.currentLanguage,
            };

            cancelSub(details, (response) => {
              // customLog("Cancel response");
              customLog(response);
              if (response.ok) {
                const delConfirmTitle = "Subscription cancelled";
                const delConfirmMessage =
                  "Your subscription has been cancelled successfully !";
                const delConfirmButton = [
                  {
                    label: "Close",
                    onClick: () => {
                      //   window.location.reload();
                      window.location.href = "/plans";
                      return false;
                    },
                  },
                ];

                //"Subscription Cancelled"
                showConfirmAlert(
                  delConfirmTitle,
                  delConfirmMessage,
                  delConfirmButton
                );
                this.setState({
                  stripeSubscriptionId: null,
                  existingPlan: false,
                  loading: false,
                });
              } // end of if(response !== ok)
            }); // end of cancelSub()
          }, //onClick
        },
        {
          label: "Cancel",
          onClick: () => {
            return false;
          },
        },
      ]; //delButton

      //"Sad to let you go"
      showConfirmAlert(delTitle, delMessage, delButton);
    } else {
      const noSubTitle = "Opps!";
      const noSubMessage =
        "It looks like you don't have any existing plan with us to cancel !";
      const noSubBtn = [
        {
          label: "Close",
          onClick: () => {
            return false;
          },
        },
      ];
      showConfirmAlert(noSubTitle, noSubMessage, noSubBtn);
    } //end of else
  }

  popupForm() {
    return (
      <div>
        <a className="close" onClick={this.closeModal}>
          &times;
        </a>
        <h2 id="planNameSelected">{this.state.planSelected}</h2>
        {/* <h3 id="planPriceSelected">{this.state.planPrice}/year</h3> */}
        {/* <h3 id="planPriceSelected">$503.16 (2 Years)</h3> */}
        <h3 id="planPriceSelected">
          {this.state.discountedDisplayPrice +
            " " +
            this.state.planDurationTitle}
        </h3>
        <input
          className={"stripeBtn-inputText"}
          type="text"
          id="creditCardName"
          placeholder="Name on Card"
          required
        />
        <input
          className={"stripeBtn-inputText"}
          type="text"
          id="creditCardAddr"
          placeholder="Billing Address"
          required
        />

        <div id="planSelectedCredentialKey">
          <CardElement
            options={{
              hidePostalCode: true,
              style: { base: { fontSize: "18px" } },
            }}
          />
        </div>
        <span id="paymentError" style={{ color: "red" }}>
          {this.state.errorMessage}
        </span>
        <button id="paymentConfirmBtn" onClick={this.submit}>
          {localizationStrings.submitButton}
        </button>
      </div>
    );
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    if (this.state.redirect) {
      return <Redirect to="/accountManagement" />;
    }
    return (
      <div id="planWrapper">
        {/* //! Notification that shows after the payment is successful. */}
        <NotificationSystem ref="notificationSystem" style={style} />
        {/* Popup form for customer to key in their credit card credentials */}

        <Popup
          open={this.state.open}
          closeOnDocumentClick
          className="planPopup"
          onClose={this.closeModal}
          children={this.popupForm}
        />
        {/*  "X" button on the top right of the popup */}

        {/* <form>
              <input type="email" placeholder={this.state.email} onChange={this.emailChange}></input>
            </form> */}
        {/* </Popup> */}

        {this.state.loading ? (
          <FadeLoader
            css={override}
            sizeUnit={"px"}
            size={125}
            color={"#a9a9a9"}
            loading={this.state.loading}
          />
        ) : (
          <div className="plansMainContainer">
            <div className="custom-plan-box">
              {/* <section id="essentialPlanLabel">2-Year Custom</section> */}
              <section id="essentialPlanLabel">
                {this.state.planNameTitle}
              </section>
              <div className="planContainer" id="customPlan">
                <section id="essentialPlanHeader" className="plansHeader">
                  {/* <h3>ESSENTIAL</h3> */}
                  <div className="planCosts">
                    <strike className={"text-cancel"}>
                      {/* <span>$718.80</span> */}
                      <span>{this.state.originalDisplayPrice}</span>
                    </strike>
                    {/* <b>
                      <span>{egeeTouchPlans.egeeTouchplan4.planPrice}</span>
                      /year
                    </b> */}
                    {/* <p>{localizationStrings.trialTitle}</p> */}
                    {/* <sub className={"discount-amount"}>-30%</sub> */}
                    <sub className={"discount-amount"}>
                      {this.state.discountDisplay}
                    </sub>
                    <br />
                    <b>
                      <span className={"discounted-price"}>
                        {/* MONTHLY - planPrice , ANNUAL - planPriceAnnual */}
                        {/* {egeeTouchPlans.egeeTouchplan4.planPrice} (2 Years) */}
                        {this.state.discountedDisplayPrice +
                          " " +
                          this.state.planDurationTitle}
                      </span>
                    </b>
                  </div>
                  <div>
                    <button
                      // className={
                      //   this.state.currentPlan === 2
                      //     ? "buyPlanBtn btnDisabled"
                      //     : "buyPlanBtn"
                      // }
                      className={
                        this.state.existingPlan && this.state.currentPlan === 9
                          ? "buyEssentialPlanBtn"
                          : !this.state.existingPlan
                          ? "buyEssentialPlanBtn"
                          : "buyEssentialPlanBtn btnDisabled"
                      }
                      // disabled={this.state.currentPlan === 2 ? true : false}
                      disabled={
                        this.state.existingPlan && this.state.currentPlan === 9
                          ? false
                          : !this.state.existingPlan
                          ? false
                          : true
                      }
                      onClick={() => this.openModal("Essential")}
                    >
                      {/* {this.state.currentPlan !== 2
                        ? "Switch to Essential"
                        : this.state.currentPlan === 2
                        ? "Current Plan"
                        : "Buy Essential"} */}
                      {/* {"Buy Custom "} */}
                      {"Activate"}
                    </button>
                  </div>
                </section>
                <div className="essentialPlanTable">
                  <p className="addAndManageText">{"ADD & MANAGE"}</p>
                  <table id="essentialPlanDetails" className="planDetails">
                    <tbody>
                      <tr>
                        <td>{localizationStrings.padlockTitle}</td>
                        <td className="customPlanDetailTableFormat">
                          {localizationStrings.uptoTitle}
                        </td>
                        <td className="planDetailTableFormat2">
                          {/* {egeeTouchPlans.egeeTouchplan4.maxLocks} */}
                          {this.state.maxLocks}
                        </td>
                      </tr>
                      <tr>
                        <td>{localizationStrings.userAccountsTitle}</td>
                        <td className="customPlanDetailTableFormat">
                          {localizationStrings.uptoTitle}
                        </td>
                        <td className="planDetailTableFormat2">
                          {/* {egeeTouchPlans.egeeTouchplan4.maxAcc} */}
                          {this.state.maxAcc}
                        </td>
                      </tr>
                      <tr>
                        <td>{localizationStrings.maxMultiTitle}</td>
                        <td className="customPlanDetailTableFormat">
                          {localizationStrings.uptoTitle}
                        </td>
                        <td className="planDetailTableFormat2">
                          {/* {egeeTouchPlans.egeeTouchplan4.maxMulti} */}
                          {this.state.maxMulti}
                        </td>
                      </tr>
                      {/* <tr>
                      <td>{localizationStrings.nfcTitle}</td>
                      <td>{egeeTouchPlans.egeeTouchplan4.maxTags}</td>
                    </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* {this.state.loading ? (
          ""
        ) : (
          <button
            className={
              this.state.existingPlan
                ? "cancelPlanBtn"
                : "cancelPlanBtn btnDisabled"
            }
            disabled={!this.state.existingPlan}
            onClick={this.cancelSub}
          >
            Cancel Subscription
          </button>
        )} */}

        {/* {this.state.loading ? (
          ""
        ) : (
          <p style={{ textAlign: "center", marginTop: "30px" }}>
            <span style={{ color: "red" }}>*</span> Note : You will be charged
            with the above pricing after 2 years on{" "}
            {new Date(
              new Date().setMonth(new Date().getMonth() + 24)
            ).toLocaleDateString("en-US", {
              // weekday: "long",
              year: "numeric",
              month: "long",
              day: "2-digit"
            })}
          </p>
        )} */}

        {this.state.loading ? (
          ""
        ) : (
          <h4 style={{ textAlign: "center", fontSize: "16px" }}>
            <span style={{ color: "red" }}>* </span>
            <a
              href="#"
              onClick={() => {
                window.open(
                  "https://www.egeetouch.com/terms-conditions",
                  "_blank"
                );
              }}
            >
              <u>{"TERMS & CONDITIONS"}</u>
            </a>
            {" APPLY "}
            <span style={{ color: "red" }}>* </span>
          </h4>
        )}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;

function CustomPlanWithElements(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <CustomPlan {...props} stripe={stripe} elements={elements} />
      )}
    </ElementsConsumer>
  );
}

export default withAuthorization(authCondition)(CustomPlanWithElements);
